<ion-content class="no-padding">
  @if(turnstileEnabled){
  <div #turnstileContainer class="#example-container" [attr.data-sitekey]="turnstileSiteKey"
    style="display: none;"></div>
  }
  @if (isLoading) {
  <div class="loading-container">
    <ion-spinner></ion-spinner>
    <p>Loading registration form...</p>
  </div>
  } @else if (loadingError) {
  <div class="error-container">
    <ion-icon name="alert-circle-outline"></ion-icon>
    <p>{{ errorMessage || 'Unable to load registration form' }}</p>
    <ion-button (click)="retry()">Retry</ion-button>
  </div>
  } @else {
  <h1 class="title-text">{{ "create-account.create" | translate }}</h1>
  <div class="description-text">
    {{ "create-account.quick" | translate }}
    <div class="info">
      <img src="assets/icon/info-ic.svg" alt="Information Icon" loading="lazy" />
      <div class="popover">
        <p>{{ "create-account.toolTipText" | translate }}</p>
      </div>
    </div>
  </div>

  @if (landingPageData) {
  <ion-grid class="payment-header-wrapper">
    <div [innerHTML]="landingPageData | safeHtml"></div>
  </ion-grid>
  }

  @if (socialLogin) {
  <div class="firebaseUI">
    <firebase-ui (signInSuccessWithAuthResult)="successCallback($event)" (signInFailure)="errorCallback($event)"
      (uiShown)="uiShownCallback()"></firebase-ui>
  </div>
  }

  <form [formGroup]="createAccountForm" autocomplete="off">
    @if (showEmail) {
    <div>
      <h1 class="input-heading">{{ "create-account.Email" | translate }}</h1>
      <ion-item class="input-fields" [ngClass]="
            createAccountForm.get('email').touched && createAccountForm.get('email')?.errors ? 'invalid-field' : ''
          " lines="none">
        <ion-input autocomplete="false" [type]="email" placeholder="{{ 'create-account.Your-email' | translate }}"
          formControlName="email" class="signupfield signup-pwd"
          [ngClass]="createAccountForm.value.email !== '' ? 'placeholderLetterSpacing' : ''"></ion-input>
      </ion-item>
      @if (createAccountForm.get('email').touched && createAccountForm.get('email')?.errors?.pattern) {
      <div class="errorContainer">
        <ion-icon name="warning" class="icon"></ion-icon>
        <span class="text">{{ "create-account.valid-email" | translate}}</span>
      </div>
      }
      @if (createAccountForm.get('email').touched && createAccountForm.get('email')?.errors?.required) {
      <div class="errorContainer">
        <ion-icon name="warning" class="icon"></ion-icon>
        <span class="text">{{ "create-account.enter-email" | translate }}</span>
      </div>
      }
    </div>
    }
    @if (showMSN) {
    <div>
      <h1 class="input-heading">{{ "create-account.Mobile" | translate }}</h1>
      <ion-grid class="ion-no-padding input-fields">
        <ion-row>
          <ion-col size="3.2" class="ion-no-padding">
            <ion-item lines="none">
              <ion-input type="tel" formControlName="dialCode" min="1" maxlength="4" placeholder="+44"
                class="signupfield" (input)="checkInput($event)" (keypress)="getNumericOnly($event)">
              </ion-input>

              <input id="dialCode" (countryChange)="onCell1CountryChange($event)"
                (intlTelInputObject)="telInputObject($event)" readonly style="display: none;" />
            </ion-item>
          </ion-col>
          <ion-col size="0.3" class="ion-no-padding"></ion-col>
          <ion-col size="8.5" class="ion-no-padding">
            <ion-item
              [ngClass]="createAccountForm.get('phoneNumber')?.errors?.incorrectPhoneNumber ? 'invalid-field' : ''"
              lines="none">
              <ion-input type="tel" placeholder="{{ 'create-account.Your' | translate }}" maxlength="11" accesskey="p"
                (hasError)="phoneNumberHasError($event)" class="signupfield signup-phone-number"
                (input)="getPhoneNumber($event)" formControlName="phoneNumber" autocomplete="false"
                (keypress)="getNumericOnly($event)" />
            </ion-item>
          </ion-col>
        </ion-row>
      </ion-grid>
      @if (createAccountForm.get('phoneNumber')?.errors?.incorrectPhoneNumber) {
      <div class="errorContainer">
        <ion-icon name="warning" class="icon"></ion-icon>
        @if (phoneInValid) {
        <span class="text">{{ "create-account.Please-valid" | translate }}</span>
        }
        @if (!phoneInValid) {
        <span class="text">{{ "create-account.enter" | translate }}</span>
        }
      </div>
      }
    </div>
    }
    @if (showDob) {
    <div>
      <h1 class="input-heading">{{ "complete-registration.Birth" | translate }}</h1>
      <ion-item class="input-fields" lines="none" [ngClass]="
          createAccountForm.get('date_of_birth').touched && createAccountForm.get('date_of_birth')?.errors
            ? 'invalid-field'
            : ''
        ">
        <ion-input (pointerdown)="openDateModal($event)" id="date" formControlName="date_of_birth"
          [placeholder]="'your-details.chooseDate' | translate">
        </ion-input>
      </ion-item>
      <ion-modal [isOpen]="isDateModalOpen" (didDismiss)="closeDateModal()" #popover class="date">
        <ng-template>
          <div class="date-picker1">
            <ion-datetime mode="ios" [preferWheel]="true" (ionChange)="onDateChange($event)"
              class="datetime-calendar" presentation="date" [value]="defaultDateOfBirth" [max]="maxDateOfBirth"
              displayFormat="M/D/YYYY" pickerFormat="MMM D YYYY" [locale]="selectedLanguage">
            </ion-datetime>
          </div>
        </ng-template>
      </ion-modal>
      @if (
        createAccountForm.get('date_of_birth').touched &&
        createAccountForm.get('date_of_birth')?.errors?.required
      ) {
      <div class="errorContainer" role="alert" aria-invalid="true" aria-describedby="dob-required-error-message">
        <ion-icon name="warning" class="icon"></ion-icon>
        <span class="text" id="dob-required-error-message">{{ "complete-registration.enter_date" | translate }}</span>
      </div>
      }
      @if (
        createAccountForm.get('date_of_birth').touched &&
        createAccountForm.get('date_of_birth')?.errors?.futureInvalidDate
      ) {
      <div class="errorContainer two-line-error-message" role="alert" aria-invalid="true"
        aria-describedby="dob-invalid-error-message">
        <ion-icon name="warning" class="icon"></ion-icon>
        <span class="text" id="dob-invalid-error-message">{{ "complete-registration.valid_age" | translate }}</span>
      </div>
      }
    </div>
    }
    <h1 class="input-heading">{{ "create-account.password" | translate }}</h1>

    <ion-item class="input-fields" [ngClass]="
          createAccountForm.get('password').touched && createAccountForm.get('password')?.errors ? 'invalid-field' : ''
        " lines="none">
      <ion-input maxlength="20" autocomplete="false" [type]="passwordType" clearOnEdit="false"
        placeholder="{{ 'create-account.password' | translate }}" formControlName="password"
        class="signupfield password-input signup-pwd"
        [ngClass]="createAccountForm.value.password !== '' ? 'placeholderLetterSpacing' : ''"></ion-input>
      @if (passwordIcon === 'eye') {
      <img class="password-reveal-icon" src="assets/icon/eye.svg" (click)="toggleViewPassword()" alt="eye-on"
        loading="lazy" />
      }
      @if (passwordIcon === 'eye-off') {
      <img class="password-reveal-icon" src="assets/icon/eye-off.svg" (click)="toggleViewPassword()" alt="eye-off"
        loading="lazy" />
      }
    </ion-item>
    @if (createAccountForm.get('password').touched && createAccountForm.get('password')?.errors?.minlength) {
    <div class="errorContainer">
      <ion-icon name="Warning" class="icon"></ion-icon>
      <span class="text">{{ "create-account.valid" | translate }}</span>
    </div>
    }
    @if (createAccountForm.get('password').touched && createAccountForm.get('password')?.errors?.required) {
    <div class="errorContainer">
      <ion-icon name="Warning" class="icon"></ion-icon>
      <span class="text">{{ "create-account.Please" | translate }}</span>
    </div>
    }

    @if (showVoucher) {
    <div>
      <h1 class="input-heading">{{ "create-account.Voucher" | translate }}</h1>
      <ion-item class="input-fields" [ngClass]="
            createAccountForm.get('voucher_code').touched && createAccountForm.get('voucher_code')?.errors
              ? 'invalid-field'
              : ''
          " lines="none">
        <ion-input autocomplete="false" [type]="text" placeholder="Your voucher" formControlName="voucher_code"
          class="signupfield signup-pwd"
          [ngClass]="createAccountForm.value.voucher_code !== '' ? 'placeholderLetterSpacing' : ''" [(ngModel)]="vc">
        </ion-input>
      </ion-item>
      @if (createAccountForm.get('voucher_code').touched && createAccountForm.get('voucher_code')?.errors?.required) {
      <div class="errorContainer">
        <ion-icon name="warning" class="icon"></ion-icon>
        <span class="text">{{ "create-account.code" | translate }}</span>
      </div>
      }
    </div>
    }
    <div>
      <p class="lost-password">
        <a class="text-link" (click)="openForgetPassword()">{{ "create-account.Forgot" | translate }}</a>
      </p>
    </div>
    <!-- lang/currency selection code -->
    <div class="selection-wrapper">
      <div class="lang-wrapper input-sm">
        <select #langSelect (change)="onLanguageChange(langSelect.value, true)" title="Language"
          [(ngModel)]="selectedLanguage" [ngModelOptions]="{standalone: true}">
          @for (lang of languageArray; track lang) {
          <option [selected]="lang?.selected" [value]="lang?.language_code">{{ lang?.language_name }}</option>
          }
        </select>
      </div>
      <div class="currency-wrapper input-sm">
        <select #currencySelect (change)="selectChange(currencySelect.value, true)" title="Currency"
          [(ngModel)]="selectedCurrency" [ngModelOptions]="{standalone: true}">
          @for (code of currencyArray; track code) {
          <option [selected]="code?.selected" [value]="code?.currency_code">
            {{ code?.currency_code }}
          </option>
          }
        </select>
      </div>
    </div>


    @if (offerState === 'loading') {
    <p role="status">Checking your offer…</p>
    }
    @if (offerState === 'error') {
    <div role="alert" class="offer-error">
      <p>{{ offerError || 'Offer details are unavailable. Please retry.' }}</p>
      <ion-button type="button" (click)="retryOffer()">Retry offer</ion-button>
    </div>
    }
    @if (offerState === 'ready' && !hasOfferCurrency()) {
    <p role="alert">This offer is unavailable in the selected currency. Please choose another currency.</p>
    }
    <ion-button expand="block" (click)="onCreateAccountFormSubmit(); startSpinner()"
      [disabled]="createAccountForm.invalid || spinnerAnimation || offerState !== 'ready' || !hasOfferCurrency()" class="action-btn-large" type="submit">
      @if (!spinnerAnimation && proceed) {
      {{ "create-account.Join" | translate }}
      }
      @if (spinnerAnimation) {
      <div class="spinners">
        <mat-progress-spinner mode="determinate" value="100" class="track-spinner" diameter="40">
        </mat-progress-spinner>
        <mat-progress-spinner class="spinner-circle" mode="determinate" [value]="progressBar" diameter="40">
        </mat-progress-spinner>
      </div>
      }
      @if (!proceed) {
      <mat-icon [@bounceIn] class="tick-mark">{{'add-card.done'|translate}}</mat-icon>
      }
    </ion-button>

    <p class="terms-disclaimer">
      {{ "create-account.accept" | translate }}
      <a (click)="showPolicy('terms_and_conditions')">{{ "create-account.terms" | translate }}</a>, {{
      "create-account.and" | translate }}
      <a (click)="showPolicy('privacy_policy')">{{ "create-account.privacy" | translate }}</a>{{"create-account.and_the"
      | translate}} <a (click)="showPolicy('preference')">{{"create-account.preference" |
        translate}}</a>. {{
      "create-account.preferences" | translate }}
      <br />
      {{ "create-account.International" | translate }}
    </p>
  </form>
  }
</ion-content>